import classnames from "classnames";
import React, { useCallback, useState } from "react";

import { Button, Textarea } from "../Common";

import "./index.scss";

interface ModalConfirmProps {
  heading: string;
  content: string;
  onClose: () => void;
  onSuccess: (reason?: string) => void;
  isCancelButton?: boolean;
  cancelBtnText?: string;
  successBtnText?: string;
  showComment?: boolean;
  commentLabel?: string;
}

const ModalConfirm = (props: ModalConfirmProps) => {
  const {
    onSuccess,
    showComment,
    cancelBtnText,
    successBtnText,
    heading,
    content,
    onClose,
    commentLabel,
    isCancelButton = true,
  } = props;
  const [comment, setComment] = useState<string | undefined>(undefined);
  const localOnSuccess = useCallback(() => {
    onSuccess(comment);
  }, [comment, onSuccess]);

  const handleCommentChange = useCallback((event: React.FormEvent<HTMLTextAreaElement>) => {
    setComment((event.target as any).value);
  }, []);

  return (
    <div className={classnames("modal-content-wrapper", { "collapsed-margin": !content && showComment })}>
      <div className="modal-heading">{heading}</div>
      <div className="modal-content">
        {content}
        {showComment && (
          <Textarea
            type="text"
            labelTitle={commentLabel}
            name="comment"
            onChange={handleCommentChange}
            maxLength={500}
            placeholder="Type your comment here..."
            cols={1}
          />
        )}
      </div>
      <div className="modal-actions">
        {isCancelButton ? (
          <Button appearance="subtle" className="subtle auto-width" onClick={onClose}>
            {cancelBtnText}
          </Button>
        ) : null}
        <Button type="submit" disabled={showComment && !comment} className="blue auto-width" onClick={localOnSuccess}>
          {successBtnText}
        </Button>
      </div>
    </div>
  );
};
export default ModalConfirm;
